var _path, _path2, _use, _use2, _use3, _use4, _use5, _use6, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMalaysia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    id: "malaysia",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cc0001",
    d: "M0-.05h640v480.1H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#fff",
    d: "M0 445.757h640v34.293H0z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "translate(0 -68.586)",
    xlinkHref: "#a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "translate(0 -137.17)",
    xlinkHref: "#a"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "translate(0 -205.757)",
    xlinkHref: "#a"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "translate(0 -274.343)",
    xlinkHref: "#a"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "translate(0 -342.93)",
    xlinkHref: "#a"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "translate(0 -411.514)",
    xlinkHref: "#a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#010066",
    d: "M0-.05h480.1v274.343H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M197.527 34.243c-56.976 0-103.222 46.09-103.222 102.878S140.55 240 197.527 240c20.585 0 39.764-6.023 55.872-16.386a91.574 91.574 0 0 1-29.93 5.007c-50.52 0-91.525-40.866-91.525-91.22 0-50.356 41.004-91.223 91.526-91.223 11.167 0 21.862 1.994 31.757 5.647-16.474-11.096-36.334-17.58-57.7-17.58z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m368.706 190.678-43.48-22.686 12.855 46.43L309 175.58l-9.073 47.272-8.923-47.298-29.205 38.75 13.002-46.39-43.552 22.555 32.353-36.292-49.273 1.892 45.296-19.01-45.235-19.145 49.267 2.04-32.238-36.39 43.48 22.686-12.856-46.428 29.08 38.838 9.074-47.27 8.923 47.297 29.206-38.75-13.003 46.39 43.552-22.555-32.353 36.293 49.273-1.892-45.296 19.01 45.234 19.145-49.266-2.04z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/malaysia.ca8aa61f804c5b9f9c44f211d1317ce4.svg";
export { ForwardRef as ReactComponent };